export function findTopElement(refs, validationErrors, emergencyCounter) {
    let top = Number.POSITIVE_INFINITY;
    let topElement = null;
    if (emergencyCounter > 100) {
        return [topElement, top];
    }
    for (const [fieldName, errors] of Object.entries(validationErrors)) {
        if (!Array.isArray(errors)) {
            const [newTopElement, newTop] = findTopElement(refs, errors, emergencyCounter + 1);
            if (newTop < top) {
                top = newTop;
                topElement = newTopElement;
            }
        }
        else if (errors.length > 0) {
            const fieldRef = refs[fieldName];
            if (fieldRef) {
                const rect = fieldRef.getBoundingClientRect();
                if (rect && rect.top) {
                    if (rect.top < top) {
                        top = rect.top;
                        topElement = fieldName;
                    }
                }
            }
        }
    }
    return [topElement, top];
}
